/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_TextInputs */

const en_body_text = /** @type {(inputs: Body_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Body Text`)
};

const es_body_text = /** @type {(inputs: Body_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuerpo de texto`)
};

const fr_body_text = /** @type {(inputs: Body_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corps du texte`)
};

const de_body_text = /** @type {(inputs: Body_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fließtext`)
};

const ja_body_text = /** @type {(inputs: Body_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本文`)
};

const zh_body_text = /** @type {(inputs: Body_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正文`)
};

const ar_body_text = /** @type {(inputs: Body_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النص الأساسي`)
};

const id_body_text = /** @type {(inputs: Body_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teks Utama`)
};

const it_body_text = /** @type {(inputs: Body_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corpo del testo`)
};

const ru_body_text = /** @type {(inputs: Body_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Основной текст`)
};

const pt_body_text = /** @type {(inputs: Body_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corpo do texto`)
};

const ko_body_text = /** @type {(inputs: Body_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`본문 텍스트`)
};

/**
* | output |
* | --- |
* | "Body Text" |
*
* @param {Body_TextInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const body_text = /** @type {((inputs?: Body_TextInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_TextInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_body_text(inputs)
	if (locale === "es") return es_body_text(inputs)
	if (locale === "fr") return fr_body_text(inputs)
	if (locale === "de") return de_body_text(inputs)
	if (locale === "ja") return ja_body_text(inputs)
	if (locale === "zh") return zh_body_text(inputs)
	if (locale === "ar") return ar_body_text(inputs)
	if (locale === "id") return id_body_text(inputs)
	if (locale === "it") return it_body_text(inputs)
	if (locale === "ru") return ru_body_text(inputs)
	if (locale === "pt") return pt_body_text(inputs)
	return ko_body_text(inputs)
});